import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import {ContentHeader} from '@components';
import Dashboard from "@app/pages/Dashboard";

const DashboardContainer = () => {
    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current
    });

  return (
    <div>
      <ContentHeader title="Dashboard" />
      <div className="col-12 d-flex justify-content-end"><a><i className="fas fa-print" onClick={handlePrint}/></a></div>
      <Dashboard ref={componentRef} />
    </div>
  );
};

export default DashboardContainer;
